import { create } from 'zustand';
import { ShiftReportDTO, ShiftReportState } from '../../typings/shiftReport';
import shiftReportService from '../../services/shiftReportService';

interface ShiftReportActions {
  fetchReports: (date?: string, shiftIds?: number[]) => Promise<void>;
  setSelectedDate: (date: string | null) => void;
  setSelectedShiftIds: (shiftIds: number[]) => void;
  reset: () => void;
}

const initialState: ShiftReportState = {
  reports: [],
  loading: false,
  error: null,
  selectedDate: null,
  selectedShiftIds: [],
};

export const useShiftReportStore = create<ShiftReportState & ShiftReportActions>((set) => ({
  ...initialState,

  fetchReports: async (date?: string, shiftIds?: number[]) => {
    set({ loading: true, error: null });
    try {
      const response = await shiftReportService.getShiftReports(date, shiftIds);
      set({ reports: response.data, loading: false });
    } catch (error) {
      console.error('Error fetching shift reports:', error);
      set({ 
        error: error instanceof Error ? error.message : 'Failed to fetch shift reports', 
        loading: false 
      });
    }
  },

  setSelectedDate: (date: string | null) => {
    set({ selectedDate: date });
  },

  setSelectedShiftIds: (shiftIds: number[]) => {
    set({ selectedShiftIds: shiftIds });
  },

  reset: () => {
    set(initialState);
  }
})); 